<template>
  <validation-provider
    #default="{ errors, valid }"
    :name="inputLabel"
    :vid="inputLabel"
    :rules="customRules"
    :custom-messages="customMessages"
  >
    <BFormGroup
      :state="errors.length > 0 ? false : null"
      :label="inputLabel"
      :label-for="inputId"
    >
      <BFormTextarea
        :readonly="readonly"
        :formatter="formatter"
        :state="errors.length > 0 ? false : null"
        :disabled="disabled"
        trim
        :rows="rows"
        :value="value"
        :size="size"
        :id="inputId"
        @input="$emit('input', $event)"
        @keydown.enter="emitEnterKeydown"
        :placeholder="inputPlaceholder"
      ></BFormTextarea>
      <small class="mt-2 text-danger" v-if="errors && errors.length > 0">
        {{ errors[0] }}
      </small>
      <div class="w-100 text-right">
        <small dir="auto" v-if="maxChars">
          {{ charsCount }} / {{ maxChars }}
        </small>
      </div>
    </BFormGroup>
  </validation-provider>
</template>

<script>
export default {
  emits: ["enter"],
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    formatter: {
      type: Function,
      default: (value) => value,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: [String, Number],
      default: 5,
    },
    size: {
      type: [String],
      default: "sm",
    },
    disabled: {
      type: [Boolean, null],
      default: false,
    },
    errorMessage: {
      type: [String, null],
      default: "این فیلد اجباری است",
    },
    charsCount: {
      type: [String, Number, null],
      default: null,
    },
    maxChars: {
      type: [String, Number, null],
      default: null,
    },
    customRules: {
      type: [String, null],
      default: null,
    },
    inputId: {
      type: String,
      required: false,
      default: "textValue",
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    inputLabel: {
      type: [String, null],
      default: "وارد کنید",
    },
    inputPlaceholder: {
      type: [String, null],
      default: "وارد کنید",
    },
    type: {
      type: String,
      default: "text",
    },
    customMessages: {
      type: Object,
      default: () => {
        return {
          required: "{_field_} اجباری است",
          min: "{_field_} حداقل باید {length} حرف باشد",
          max: "{_field_} حداکثر باید {length} حرف باشد",
          between: "{_field_} باید بین {min} و {max} باشد",
        };
      },
    },
  },
  data() {
    return {
      required,
      max,
    };
  },
  methods: {
    emitEnterKeydown() {
      this.$emit("enter");
    },
  },
  components: {
    BFormTextarea,
    BFormGroup,
    ValidationProvider,
  },
};
import { required, max } from "@validations";
import { ValidationProvider } from "vee-validate";
import { BFormTextarea, BFormGroup } from "bootstrap-vue";
</script>
